<!--IMPORTANT-->
<!--THERE ARE TWO SETS OF CODE THAT DOES THE SAME THING-->
<!--ONE FOR MOBILE, ONE FOR NON MOBILE-->
<!--NEED THIS BECAUSE MOBILE DIALOG NEEDS TO BE FULL SCREEN-->
<!--SO IF YOU NEED TO MAKE A CHANGE, BE SURE TO CHANGE BOTH-->
<template>
  <div>
    <!--user preference icon, opens up dialog-->
    <!--mobile dialog-->
    <v-dialog
      v-if="isMobile"
      v-model="dialog"
      fullscreen>
      <!--dialog text-->
      <v-card>
        <v-card-title
          :class="{'title': !isMobile, 'subheading': isMobile}"
          class="primary white--text">
          User Preferences
          <v-spacer></v-spacer>
          <v-icon
            @click="dialog = false"
            class="white--text">
            close
          </v-icon>
        </v-card-title>
        <v-list v-if="!showLoading" two-line>
          <!--tooltips-->
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="primary--text">
                Tooltips: Helpful hints throughout the app
              </v-list-tile-title>
              <v-list-tile-sub-title>
                Click the star to turn tooltips OFF and ON.
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action @click="toggleTooltip">
              <span v-if="showTooltip === 'enabled'">
                <v-icon color="secondary">star</v-icon>
              </span>
              <span v-else>
                <v-icon>star_border</v-icon>
              </span>
            </v-list-tile-action>
          </v-list-tile>
          <template v-if="userPreferencesArray && userPreferencesArray.length">
            <v-divider></v-divider>
            <!--repeatable user preferences-->
            <span
              v-for="(preference, i) in userPreferencesArray"
              :key="i">
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="primary--text">
                    {{preference.displayName}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    Select this to have the {{preference.displayName}}
                    as your default view on login.
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action @click="setUserPreference(preference.value)">
                  <span v-if="defaultView == preference.value">
                    <v-icon color="secondary">star</v-icon>
                  </span>
                  <span v-else>
                    <v-icon>star_border</v-icon>
                  </span>
                </v-list-tile-action>
              </v-list-tile>
              <span v-if="i < userPreferencesArray.length - 1">
                <v-divider></v-divider>
              </span>
              </span>
          </template>
        </v-list>
        <v-alert type="error" :value="errorMsg">
          {{errorMsg}}
        </v-alert>
        <div v-if="showLoading" class="text-xs-center py-3">
          <loading-spinner></loading-spinner>
        </div>
      </v-card>
    </v-dialog>
    <!--non mobile dialog-->
    <v-dialog
      v-if="!isMobile"
      v-model="dialog"
      width="700">
      <!--dialog text-->
      <v-card>
        <v-card-title
          :class="{'title': !isMobile, 'subheading': isMobile}"
          class="primary white--text">
          User Preferences
        </v-card-title>
        <v-list v-if="!showLoading" two-line>
          <!--tooltips-->
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="primary--text font-bold">
                Tooltips: Helpful hints throughout the app
              </v-list-tile-title>
              <v-list-tile-sub-title>
                Click the star to turn tooltips OFF and ON.
              </v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action @click="toggleTooltip">
              <span v-if="showTooltip === 'enabled'">
                <v-icon color="secondary">star</v-icon>
              </span>
              <span v-else>
                <v-icon>star_border</v-icon>
              </span>
            </v-list-tile-action>
          </v-list-tile>
          <template v-if="userPreferencesArray && userPreferencesArray.length">
            <v-divider></v-divider>
            <!--repeatable user preferences-->
            <span
              v-for="(preference, i) in userPreferencesArray"
              :key="i">
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title class="primary--text font-bold">
                    {{preference.displayName}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    Select this to have the {{preference.displayName}}
                    as your default view on login.
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action @click="setUserPreference(preference.value)">
                  <span v-if="defaultView == preference.value">
                    <v-icon color="secondary">star</v-icon>
                  </span>
                  <span v-else>
                    <v-icon>star_border</v-icon>
                  </span>
                </v-list-tile-action>
              </v-list-tile>
              <span v-if="i < userPreferencesArray.length - 1">
                <v-divider></v-divider>
              </span>
              </span>
          </template>
        </v-list>
        <v-alert type="error" :value="errorMsg">
          {{errorMsg}}
        </v-alert>
        <div v-if="showLoading" class="text-xs-center py-3">
          <loading-spinner></loading-spinner>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import JWTHelper from '@/jwt-token';
import api from '@/utils/api';
import LoadingSpinner from '@/components/loading-spinner';
import * as Constants from '@/constants';

export default {
  name: 'UserPreferences',
  components: {
    LoadingSpinner
  },
  data() {
    return {
      dialog: false,
      showUserPreferences: false,
      showTooltip: '',
      defaultView: '',
      userPreferencesArray: '',
      showLoading: false,
      userId: '',
      errorMsg: ''
    };
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  created() {
    // set the userId to use throughout this component
    this.userId = JWTHelper.user().userId;
    this.showLoading = true;
    // get the users preference for tooltips
    api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'ot_help'))
      .then((response) => {
        this.showTooltip = response.data.data.value;
        // if the user has access to the service logs and scheduler app
        if (JWTHelper.hasFullRights()) {
          this.getRightsForUsersWithFullAccess();
        }
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.message) {
          this.errorMsg = error.response.data.message;
        } else {
          this.errorMsg = error.message;
        }
      })
      .finally(() => {
        this.showLoading = false;
      });
  },
  methods: {
    /**
     * This function should only be called if the user has access to
     * the scheduler app and service log app
     * Promise 1 gets the users preference for default view
     * Promise 2 gets teh options available for default views
     */
    getRightsForUsersWithFullAccess() {
      Promise.all(
        [
          api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'ot_menu_default')),
          api.get(Constants.GET_USER_PREFERENCE_VALUE_OPTIONS_URL(this.userId, 'ot_menu_default'))
        ])
        .then((response) => {
          this.defaultView = response[0].data.data.value;
          this.userPreferencesArray = response[1].data.data;
        });
    },
    toggleTooltip() {
      this.showLoading = true;
      const body = {
        userId: this.userId,
        preferenceKey: 'ot_help',
        value: this.showTooltip === 'enabled' ? 'disabled' : 'enabled'
      };
      // update the tooltip preference
      api.put(Constants.UPDATE_USER_PREFERENCE_URL(this.userId, 'ot_help'), body)
        .then(() => {
          // get the new tooltip preference
          return api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'ot_help'));
        })
        .then((response) => {
          this.showTooltip = response.data.data.value;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          // update the store with the tooltip preference
          this.$store.commit('tooltip', this.showTooltip === 'enabled');
          this.showLoading = false;
        });
    },
    setUserPreference(preference) {
      this.showLoading = true;
      const body = {
        userId: this.userId,
        preferenceKey: 'ot_menu_default',
        value: preference
      };
      // update the preference
      api.put(Constants.UPDATE_USER_PREFERENCE_URL(this.userId, 'ot_menu_default'), body)
        .then(() => {
          // get updated preference
          return api.get(Constants.GET_USER_PREFERENCES_WITH_KEY_URL(this.userId, 'ot_menu_default'));
        })
        .then((response) => {
          this.defaultView = response.data.data.value;
        })
        .catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.errorMsg = error.response.data.message;
          } else {
            this.errorMsg = error.message;
          }
        })
        .finally(() => {
          this.showLoading = false;
        });
    }
  },
  mounted() {
    this.dialog = true;
  },
  watch: {
    dialog() {
      if (!this.dialog) this.$emit('dialog:closed');
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/user-preferences.vue